<template>
  <div class="brand" v-show="!isMobile">
    <div class="round"></div>
    <div class="title">
      <h1 class="title">品牌厂商接入米家</h1>
      <div class="des-00">
        <span>乐式项目经理全程跟进</span>
        <span>|</span>
        <span>极速落地量产</span>
        <span>|</span>
        <span>配套供应链</span>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <a href="javascript:;" class="btn" @click="onRedirect">
          <span>商务确认</span>
          <div class="icon">
            <icon-svg icon-class="yonghu" />
          </div>
        </a>
        <a href="javascript:;" class="btn" @click="onRedirect">
          <span>方案确认</span>
          <div class="icon">
            <icon-svg icon-class="copy" />
          </div>
        </a>
        <a href="javascript:;" class="btn" @click="onRedirect">
          <span>创建品牌</span>
          <div class="icon">
            <icon-svg icon-class="add" />
          </div>
        </a>
        <a href="javascript:;" class="btn" @click="onRedirect">
          <span>项目开发</span>
          <div class="icon">
            <icon-svg icon-class="webcodelanguageprogramwebdesigncompu" />
          </div>
        </a>
        <a href="javascript:;" class="btn" @click="onRedirect">
          <span>品牌上架</span>
          <div class="icon">
            <icon-svg icon-class="shangjia" />
          </div>
        </a>
        <a href="javascript:;" class="btn" @click="onRedirect">
          <span>批量生成</span>
          <div class="icon">
            <icon-svg icon-class="shuangchilun" />
          </div>
        </a>
        <div class="description">
          <img class="logo" src="./resources/logo_mihome.png" alt srcset />
          <span class="des-01">小米将对接入的品牌厂商授予以下商标使用</span>
          <span class="des-01">具体以平台实时规则为准</span>
        </div>
      </div>
      <div class="right">
        <div class="box">
          <div class="col">
            <div class="tit">品牌客户</div>
            <div class="desc">
              <span>沟通商务合作方式</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">乐式服务</div>
            <div class="desc">
              <span>1、推荐品牌厂商与小米对接；</span>
              <span>2、签订商务合同</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">小米服务</div>
            <div class="desc">
              <span>----</span>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="col">
            <div class="tit">品牌客户</div>
            <div class="desc">
              <span>对乐式提出产品功能需求</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">乐式服务</div>
            <div class="desc">
              <span>1、根据米家IOT规范评估客户需求，帮助客户完成产品功能定义；</span>
              <span>2、推荐硬件选型及H5界面方案</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">小米服务</div>
            <div class="desc">
              <span>----</span>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="col">
            <div class="tit">品牌客户</div>
            <div class="desc">
              <span>对乐式提供品牌资料及产品资料</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">乐式服务</div>
            <div class="desc">
              <span>1、协助客户完成小米IOT品牌账号注册；</span>
              <span>2、协助客户完成米家平台产品功能参数注册；</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">小米服务</div>
            <div class="desc">
              <span>----</span>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="col">
            <div class="tit">品牌客户</div>
            <div class="desc">
              <span>样品调试及确认</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">乐式服务</div>
            <div class="desc">
              <span>1、硬件模组嵌入式开发；</span>
              <span>2、页面H5开发；</span>
              <span>3、严格按照小米规范，完成产品上架测试及技术文档；</span>
              <span>4、协助客户完成功能联调；</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">小米服务</div>
            <div class="desc">
              <span>----</span>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="col">
            <div class="tit">品牌客户</div>
            <div class="desc">
              <span>送样小米</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">乐式服务</div>
            <div class="desc">
              <span>1、提供上架所需技术测试资料；</span>
              <span>2、协助客户完成平台产品提测上架；</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">小米服务</div>
            <div class="desc">
              <span>----</span>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="col">
            <div class="tit">品牌客户</div>
            <div class="desc">
              <span>安排产品量产试产</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">乐式服务</div>
            <div class="desc">
              <span>1、模组备货及供应；</span>
              <span>2、提交产测标准；</span>
              <span>3、提交产测工具；</span>
              <span>4、提供技术指导；</span>
            </div>
          </div>
          <div class="col">
            <div class="tit">小米服务</div>
            <div class="desc">
              <span>----</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _isMobile } from '@/utils/config';

export default {
  name: 'brand',
  // 与父组件通信
  props: {},
  // 组件
  components: {},
  // 数据
  data() {
    return {
      isMobile: _isMobile(),
    };
  },
  // 监听
  watch: {},
  // 挂载结束状态
  mounted() {},
  // 方法
  methods: {
    onRedirect: function (url) {
      console.log(url);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import './index.less';
</style>

 